import { api } from './api'
import { PracticeLocation, PracticeLocationFormData } from '../types/practiceLocation'

export const practiceLocationService = {
  /**
   * Get current practice location configuration
   */
  getCurrent: async (): Promise<PracticeLocation> => {
    const response = await api.get<PracticeLocation>('/settings/practice-location')
    return response.data
  },

  /**
   * Update practice location configuration
   */
  update: async (data: PracticeLocationFormData): Promise<PracticeLocation> => {
    const response = await api.put<PracticeLocation>('/settings/practice-location', data)
    return response.data
  },
}
